import React from 'react';
import { Link } from "react-router-dom";

import inverterbanner from '../img/services/inverter-ups/inverter-ups-banner.jpg';
import invertermanufacturing from '../img/services/inverter-ups/inverter-manufacturing.jpg';
import inverterupsmanufacturing1 from '../img/services/inverter-ups/inverter-ups-manufacturing1.JPG';
import inverterupsmanufacturing2 from '../img/services/inverter-ups/inverter-ups-manufacturing2.jpg';
import inverterupsmanufacturing3 from '../img/services/inverter-ups/inverter-ups-manufacturing3.jpeg';
import inverterupsmanufacturing4 from '../img/services/inverter-ups/inverter-ups-manufacturing4.JPG';
import inverterupsmanufacturing5 from '../img/services/inverter-ups/inverter-ups-manufacturing5.JPG';
import inverterupsmanufacturing6 from '../img/services/inverter-ups/inverter-ups-manufacturing6.JPG';
import inverterupsmanufacturing7 from '../img/services/inverter-ups/inverter-ups-manufacturing7.jpg';
import inverterupsmanufacturing8 from '../img/services/inverter-ups/inverter-ups-manufacturing8.jpg';
import inverterupsmanufacturing9 from '../img/services/inverter-ups/inverter-ups-manufacturing9.jpg';
import inverterupsmanufacturing10 from '../img/services/inverter-ups/inverter-ups-manufacturing10.jpg';
import lithiuminverterups from '../img/services/inverter-ups/lithium-inverter-ups.jpg';
import lithiuminvertervideo from '../img/services/inverter-ups/lithium-inverter-video.jpg';

import IndustrialInverter from '../catalogues/inverter/Finike Lithium Industrial Inverters.pdf';
import PWMSolarInverter from '../catalogues/inverter/Finike Lithium PWM Solar Inverter.pdf';
import WaveHomeInverter from '../catalogues/inverter/Finike Lithium Sine Wave Home Inverters .pdf';
import HybridHomeInverter from '../catalogues/inverter/Finike Lithium Solar Hybrid Home Inverter.pdf';
import FLSolarInverter from '../catalogues/inverter/Finike Lithium Solar Inverter.pdf';
import SolarInverter from '../catalogues/inverter/Finike LithiumMPPT Solar Inverter.pdf';
import lithuminverterups from '../catalogues/inverter/Final catalogue Inverters.pdf';

import lithiuminvertersvideo from '../video/lithiuminvertorvideo.mp4';

function Inverterups() {
  return (
    <div className="page-content">

  <div
    className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
    data-stellar-background-ratio="0.5"
    style={{
      backgroundImage: `url(${inverterbanner}) `
    }}
  >
    <div className="overlay-main bg-black opacity-07" />
    <div className="container">
      <div className="sx-bnr-inr-entry">
        <div className="banner-title-outer">
          <div className="banner-title-name">
            <h2 className="m-tb0">Lithium Inverter &amp; UPS Manufacturing</h2>
            <p>
              Spinoff Technopark Ltd. manufactures robust, efficient
              inverters and UPS systems for reliable power backup.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  {/* INNER PAGE BANNER END */}
  {/* SECTION CONTENT START */}
  <div className="section-full p-t80 p-b50 mobile-page-padding">
    <div className="container">
      {/* GALLERY CONTENT START */}
      <div className="row">
        <div className="col-lg-4 col-md-12 sticky_column">
          <div className="about4-section m-b20 bg-gray p-a20">
            {/*
            <div className="widget widget_services">
              <h4 className="widget-title">Our Business Verticals</h4>
              <ul className="bg-white">
                <li>
                   <Link to="/our-services/led-lights">Led Lights</Link>
                </li>
                <li>
                  <Link to="/our-services/lithium-battery">Lithium Battery</Link>
                </li>
                <li>
                  <Link to="/our-services/sheet-metal">CNC Lazer Cut Machines</Link>
                </li>
              </ul>
            </div>*/}
              <div className="wt-icon-box-wraper left p-a15 m-b10">
              <a
                href={IndustrialInverter}
                className="btn-block"
                target="_blank"
              >
            
                <strong className="text-uppercase text-black">
              
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={lithuminverterups}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Lithium Inverter/UPS
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={IndustrialInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Industrial Inverter
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={PWMSolarInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  PWM Solar Inverter
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={WaveHomeInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Sine Wave Home Inverter
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={HybridHomeInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Hybrid Home Inverter
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={FLSolarInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  FL Solar Inverter
                </strong>
              </a>
            </div>
            <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
              <a
                href={SolarInverter}
                className="btn-block"
                target="_blank"
              >
                <span className="text-black m-r10">
                  <i className="fa fa-file-pdf-o" />
                </span>
                <strong className="text-uppercase text-black">
                  Solar Inverter
                </strong>
              </a>
            </div>
            {/*<div className="about4-content m-t30">
              <h4>GET SPECIAL OFFER</h4>
              <p>Contact us Now and Get Special offer on your Projects</p>
              <a
                href="https://wa.link/jb4lfe"
                className="site-button-link"
                target="_blank"
              >
                Chat with us!
              </a>
            </div>*/}
          </div>
        </div>
        <div className="col-lg-8 col-md-12">
          <div className="section-content">
            <div className="service-single-block m-b30">
              <div className="sx-media">
                <img
                  src={lithiuminverterups}
                  alt=""
                />
              </div>
              <h3 className="m-t30 sx-tilte">
                Discover the Benefits of Inverters and UPS Systems by Spinoff
                Technopark Ltd.
              </h3>
              <p>
                In today's dynamic world, uninterrupted power supply is not just
                a convenience but a necessity for both homes and businesses
                alike. At Spinoff Technopark Ltd., we understand the
                critical role that reliable power solutions play in your daily
                operations and peace of mind. As a trusted manufacturer we
                specialize in crafting high-quality inverters and UPS systems
                designed to meet the diverse needs of our customers.
              </p>
              <h4 className="m-t30 sx-tilte">
                Why Choose Spinoff Technopark Inverters and UPS Systems?
              </h4>
              <div className="single-service-list">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <ul className="list-angle-right anchor-line">
                      <li>Robust Performance</li>
                      <li>Advanced Technology</li>
                      <li>Versatility</li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <ul className="list-angle-right anchor-line">
                      <li>Battery Safety</li>
                      <li>Ease of Maintenance</li>
                      <li>Customization Options</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="sx-media sx-img-effect zoom-slow">
                <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                  <img
                    src={lithiuminvertervideo}
                    alt=""
                  />
                  <a
                    href={lithiuminvertersvideo}
                    className="mfp-video play-now"
                    target='_blank'
                  >
                    <i className="icon fa fa-play" />
                    <span className="ripple" />
                  </a>
                </div>
              </div>
            </div>
            <div className="sx-accordion acc-bg-gray m-b30" id="accordion5">
              <div className="panel sx-panel">
                <div className="acod-head acc-actives">
                  <h6 className="acod-title">
                    <a
                      data-toggle="collapse"
                      href="#collapseOne5"
                      data-parent="#accordion5"
                    >
                      Why choose Spinoff inverters?
                      <span className="indicator">
                        <i className="fa" />
                      </span>
                    </a>
                  </h6>
                </div>
                <div id="collapseOne5" className="acod-body collapse show">
                  <div className="acod-content p-tb15">
                    <p>
                      {" "}
                      Reliable, efficient power backup solutions for homes and
                      businesses
                    </p>
                  </div>
                </div>
              </div>
              <div className="panel sx-panel">
                <div className="acod-head">
                  <h6 className="acod-title">
                    <a
                      data-toggle="collapse"
                      href="#collapseTwo5"
                      className="collapsed"
                      data-parent="#accordion5"
                    >
                      What are the benefits of UPS systems?
                      <span className="indicator">
                        <i className="fa" />
                      </span>
                    </a>
                  </h6>
                </div>
                <div id="collapseTwo5" className="acod-body collapse">
                  <div className="acod-content p-tb15">
                    Ensures uninterrupted operation of critical equipment during
                    power outages.
                  </div>
                </div>
              </div>
              <div className="panel sx-panel">
                <div className="acod-head">
                  <h6 className="acod-title">
                    <a
                      data-toggle="collapse"
                      href="#collapseThree5"
                      className="collapsed"
                      data-parent="#accordion5"
                    >
                      How do Spinoff products enhance energy efficiency?
                      <span className="indicator">
                        <i className="fa" />
                      </span>
                    </a>
                  </h6>
                </div>
                <div id="collapseThree5" className="acod-body collapse">
                  <div className="acod-content p-tb15">
                    Minimize electricity consumption while maintaining optimal
                    performance and reliability.
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 m-b30">
                <div className="sx-icon-box-wraper p-a30  center bg-white shadow">
                  <div className="sx-icon-box-lg inline-icon text-primary  m-b20 radius bg-secondry  scale-in-center">
                    <span className="icon-cell sx-text-primary">
                      <i className="flaticon-ruler-1" />
                    </span>
                  </div>
                  <div className="icon-content">
                    <h4 className="sx-tilte">Power Without Interruption</h4>
                    <p>
                      Ensure uninterrupted operation of your critical equipment
                      with our efficient and robust UPS solutions.
                    </p>
                    {/* <a href="#" class="site-button-link">Read More</a> */}
                  </div>
                </div>
              </div>
              <div className="col-md-6 m-b30">
                <div className="sx-icon-box-wraper p-a30  center bg-white shadow">
                  <div className="sx-icon-box-lg inline-icon text-primary  m-b20 radius bg-secondry  scale-in-center">
                    <span className="icon-cell sx-text-primary">
                      <i className="flaticon-blueprint-1" />
                    </span>
                  </div>
                  <div className="icon-content">
                    <h4 className="sx-tilte">Efficiency Redefined</h4>
                    <p>
                      Experience reliable and energy-efficient power backup
                      solutions tailored to your residential and commercial
                      needs
                    </p>
                    {/* <a href="#" class="site-button-link">Read More</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* GALLERY CONTENT END */}
    </div>

    {/* Similar projects START */}
    <div className="section-full p-tb80 bg-gray inner-page-padding">
      <div className="container">
        <div className="section-content">
          {/* TITLE START */}
          <div className="section-head">
            <div className="sx-separator-outer separator-left">
              <div
                className="sx-separator bg-white bg-moving bg-repeat-x"
                style={{
                  backgroundImage: "url(/images/background/cross-line2.png)"
                }}
              >
                <h3 className="sep-line-one">
                  Lithium Inverter &amp; UPS Gallery
                </h3>
              </div>
            </div>
          </div>
          {/* TITLE END */}
          <div className="work-carousel-outer">
            <div className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80">
              {/* COLUMNS 1 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing1}
                      alt=""
                    />
                    {/*<div className="figcaption">
                      <a
                        className="mfp-link"
                        href="/img/services/inverter-ups/inverter-ups-manufacturing1.jpg"
                      >
                        <i className="fa fa-arrows-alt" />
                      </a>
                    </div>*/}
                  </div>
                </div>
              </div>
              {/* COLUMNS 2 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing2}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 3 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing3}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 4 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing4}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 5 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing5}
                      alt=""
                    />
                
                  </div>
                </div>
              </div>
              {/* COLUMNS 6 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing6}
                      alt=""
                    />
                  
                  </div>
                </div>
              </div>
              {/* COLUMNS 7 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing7}
                      alt=""
                    />
                  
                  </div>
                </div>
              </div>
              {/* COLUMNS 8 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing8}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
              {/* COLUMNS 9 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing9}
                      alt=""
                    />
                  
                  </div>
                </div>
              </div>
              {/* COLUMNS 10 */}
              <div className="item">
                <div className="project-mas m-a30">
                  <div className="image-effect-one">
                    <img
                      src={inverterupsmanufacturing10}
                      alt=""
                    />
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

  );
}

export default Inverterups;
